import {
    SkyNetDomainConfigParams,
} from 'app/PoC/DataGridDemoPages/SkyNetDomainV2/SkyNetDomain.types'

// eslint-disable-next-line import/prefer-default-export
export const prepareMasterConfig = (domainConfig: SkyNetDomainConfigParams<any>) => {
    return domainConfig.config.map((tabConfig) => {
        return {
            ...tabConfig,
            columns: tabConfig.columns || domainConfig.columns,
            formViews: tabConfig.formViews || domainConfig.formViews,
        }
    })
}
